import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: JSON.parse(localStorage.getItem('user')) || null
	},
	mutations: {
		setUser(state, user) {
			state.user = user;
			if (user) {
				localStorage.setItem('user', JSON.stringify(user));
			} else {
				localStorage.removeItem('user');
			}
		},
		updateUser(state, userData) {
			state.user = { ...state.user, ...userData };
			localStorage.setItem('user', JSON.stringify(state.user));
		}
	},
	actions: {
		login({ commit }, userData) {
			commit('setUser', userData);
		},
		logout({ commit }) {
			commit('setUser', null);
		}
	},
	getters: {
		isLoggedIn: state => !!state.user,
		userToken: state => state.user ? state.user.token : null,
		userId: state => state.user ? state.user.id : null
	}
}) 